import { 
    ORDERS_VIEW_ROUTER, 
    // ORDERS_VIEW_ROUTER_URL 
} from '@Router/routerPath';
import OrderViewPage from '@Local/Orders/OrderViewPage/OrderViewPage';
import { FRONT_KEY } from '@Constants/frontKey';

const OrdersRouter = [
    // {
    //     description: '訂單管理',
    //     frontKey: 'H8X01',
    // },
    {
        description: '訂單頁',
        frontKey: FRONT_KEY.ORDERS_VIEW,
        // frontKey: 'CXX99004',
        static: true,
        exact: true,
        path: ORDERS_VIEW_ROUTER,
        // href: ORDERS_VIEW_ROUTER_URL,
        as: OrderViewPage,
    },
];

export default OrdersRouter;
